import React from 'react'
import { useIntl } from 'react-intl'
import brandingConfig from '../../../../../config/brandingConfig'

export default function RoomPreviewFooter() {
  const { formatMessage } = useIntl()
  const currentYear = new Date().getFullYear()

  const Host = window.location.host
  const protocol = window.location.protocol
  const registrationUrl = Host.includes('localhost')
    ?
    `/auth/registration/?lp=generic&utm_source=recordskeeper.ai&utm_medium=web-app&utm_campaign=data-room-public-view`
    :
    `${protocol}//${Host}/auth/registration/?lp=generic&utm_source=recordskeeper.ai&utm_medium=web-app&utm_campaign=data-room-public-view`

  return (
    <div className='room-preview-footer-wrapper d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-md-between'>
      <div className='room-preview-footer-left'>
        <p
          className='text-gray-500 m-0'
          dangerouslySetInnerHTML={{
            __html: `${currentYear} &copy; ${brandingConfig.companyDetails.displayName}`,
          }}
        />
      </div>
      <div className='d-flex flex-row align-items-center room-preview-footer-center'>
        <span className='me-3'>{formatMessage({ id: 'Powered By' })}</span>
        {/* <a
          href={`${Host.includes('localhost') ? '' : 'https://'}${Host}/auth/registration/?lp=generic&utm_source=recordskeeper.ai&utm_medium=web-app&utm_campaign=file-download-page`}
        > */}
        <a href={registrationUrl}>
          <img
            height={54}
            width={381}
            alt={brandingConfig.brandName}
            src={brandingConfig.lightModeLogo}
          />
        </a>
      </div>
      <div className='d-flex'>
        <a
          href={brandingConfig.termsUrl}
          className='me-4 text-gray-500'
          target='_blank'
          rel='noreferrer'
        >
          {formatMessage({ id: 'Terms of use' })}
        </a>
        <a
          href={brandingConfig.privacyUrl}
          className='text-gray-500'
          target='_blank'
          rel='noreferrer'
        >
          {formatMessage({ id: 'Privacy Policy' })}
        </a>
      </div>
    </div>
  )
}
